import { useSnackbar } from 'notistack';

import { trpc } from '../../../trpc';
import { statusChangeErrorMessage } from '../../snackbars/updateStatusOfVeranstaltungSnackbars';

export function useLeistungStatusMutation() {
  const { enqueueSnackbar } = useSnackbar();
  const utils = trpc.useUtils();

  return trpc.leistung.updateStatusOfLeistung.useMutation({
    onError: () => {
      enqueueSnackbar(statusChangeErrorMessage, { variant: 'error', persist: true });
    },
    onSuccess: async (result) => {
      await Promise.all([
        utils.durchgang.getDurchgangByAkaDurchgangId.invalidate(),
        utils.durchgang.getDurchgaengeByAkaThemaIds.invalidate(),
        utils.veranstaltung.getVeranstaltungByAkaVeranstaltungId.invalidate(),
        utils.veranstaltung.getVeranstaltungenByAkaThemaIds.invalidate(),
      ]);

      if (result.errorMessages.length > 0) {
        result.errorMessages.forEach((errorMessage) => {
          enqueueSnackbar(errorMessage, { variant: 'error', persist: true });
        });
        return;
      }

      if (result.successMessages.length > 0) {
        result.successMessages.forEach((successMessage) => {
          enqueueSnackbar(successMessage, { variant: 'success' });
        });
      }
    },
  });
}
